<template>
  <div class="commentAll">
    <!-- <confirm><confirm> -->
    <!--评论区域 begin-->
    <div class="reviewArea clearfix">
      <div class="comment-show-con-img pull-left">
          <router-link tag="a" :to="'/homepage'">
               <img :src="userInfo.Avatar" alt>                 
           </router-link>
        
      </div>
      <div class="pl-text-top clearfix" v-if="userInfo.JobNo">
        <router-link tag="a" :to="'/homepage'">
                 <span class="comment-size-number">NO. {{userInfo.JobNo}}</span>
                 <a href="#" class="comment-size-name">{{userInfo.Name}}</a>              
        </router-link>
      </div>
      <textarea class="content comment-input frist-input" placeholder="说点什么……" v-model="mycount"></textarea>
      <a href="javascript:;" class="plBtn" @click="CreateComment(-1,-1,mycount)">添加评论</a>
    </div>
    <!--评论区域 end-->
    <div class="comment-all-text">
      全部评论
      <span>{{commentdata.TotalCount}}</span>
    </div>
    <!--回复区域 begin-->
    <div class="comment-show">
      <div class="comment-show-con clearfix" v-for="(row,index1) in commentdata.Items" :key="index1">
        <div class="comment-show-con-list pull-left clearfix">
          <div  class="comment-div">
            
            <div class="comment-show-con-img pull-left">
                <router-link tag="a" :to="row.PublishID!=userInfo.Id?'/personInfo/'+row.PublishID:'/homepage'">
                   <img :src="row.Avatar" alt>
                 </router-link>
            
            </div>
            <div class="l-text pull-left clearfix">
              <div class="pl-text clearfix">
                <router-link tag="a" :to="row.PublishID!=userInfo.Id?'/personInfo/'+row.PublishID:'/homepage'">
                <span class="comment-size-number">NO.{{row.JobNo}}</span>
                <a href="#" class="comment-size-name">{{row.Name}}</a>
                </router-link>
                <span class="comment-time">{{row.CreationFormatTime}}</span>
                
              </div>
              <div class="date-dz">
                <span class="date-dz-left pull-left my-pl-con">{{row.Content}}</span>
                <div class="date-dz-right pull-right comment-pl-block">
                  <a href="javascript:;" class="removeBlock" v-if="row.PublishID==userInfo.Id"
                    @click="delComment(row.Id,index1,-1)">删除</a>
                  <div class="date-dz-pl pl-hf hf-con-block pull-left" @click="addcomment(index1,-1)">
                    {{row.AnswerCount}}</div>
                  <div class="date-dz-z pull-left" :class="{like:row.LikeId>0}"
                    @click="DelOrLike(row.LikeId,row.Id,index1,-1)">{{row.LikeCount}}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 回复框 -->
          <div class="hf-con clearfix" v-if="row.flag">
            <textarea class="content comment-input hf-input" :placeholder="commentname(row.Name)"
              v-model="row.count"></textarea>
            <div class="hf-pl pull-left" @click="CreateComment(index1,-1,row.count,row.Id,row.PublishID,row.Name)">回复
            </div>
          </div>

          <!-- 回复框 -->
          <div class="hf-list-con" v-if="row.AnswerList&&row.AnswerList.length>0">
            <img class="hf-list-icon" src="../../assets/img/triangle_icon.png" alt>
            <div v-for="(item, index2) in row.AnswerList" :key="index2">
              <div class="all-pl-con clearfix">
                <div class="comment-show-con-img pull-left">
                <router-link tag="a" :to="item.PublishID!=userInfo.Id?'/personInfo/'+item.PublishID:'/homepage'">
                 <img :src="item.Avatar" alt>
                </router-link>
                </div>
                <div class="l-text-x pull-left">
                  <div class="pl-text clearfix">
                    <router-link tag="a" :to="item.PublishID!=userInfo.Id?'/personInfo/'+item.PublishID:'/homepage'">
                    <span class="comment-size-number">{{item.JobNo}}</span>
                    <a href="#" class="comment-size-name">{{item.Name}}</a>
                     </router-link>
                    <span class="comment-time">{{item.CreationFormatTime}}</span>
               

                  </div>
                  <div class="date-dz">
                    <span class="date-dz-left pull-left my-pl-con">回复@{{item.AnswerName}}：</span>
                    <span class="date-dz-left pull-left my-pl-con">{{item.Content}}</span>
                    <div class="date-dz-right pull-right comment-pl-block">
                      <a href="javascript:;" class="removeBlock" v-if="item.PublishID==userInfo.Id"
                        @click="delComment(item.Id,index1,index2)">删除</a>
                      <div class="date-dz-pl pl-hf hf-con-block pull-left" @click="addcomment(index1,index2)"></div>
                      <div href="javascript:;" class="date-dz-z pull-left" :class="{like:item.LikeId?true:false}"
                        @click="DelOrLike(item.LikeId,item.Id,index1,index2)">{{item.LikeCount}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="hf-con clearfix" v-if="item.flag">
                <textarea class="content comment-input hf-input" :placeholder="commentname(item.Name)"
                  v-model="item.count"></textarea>
                <a href="javascript:;" class="hf-pl pull-left"
                  @click="CreateComment(index1,index2,item.count,row.Id,item.PublishID,item.Name)">回复</a>
              </div>
            </div>
            <div class="comment-show—more" v-if="row.AnswerCount>row.AnswerList.length"
              @click="getMoreAnswer(row.Id,index1,row.AnswerList.length)">更多回复</div>
          </div>
        </div>
      </div>
    </div>
    <!--回复区域 end-->
    <div class="comment-show—more" v-if="commentdata.Items.length<commentdata.TotalCount"
      @click="getMoreCount(commentdata.Items.length)">更多评论</div>
    <!-- 确认框 -->
    <confirm ref="confirm" @handelConfirm="confirmDelComment"></confirm>
    <login :isShow="isShow" :bgShow="bgShow" @close="close"></login>
  </div>
</template>
<script>
  import {
    GetSourceListAsync,
    CreateAsync,
    DeleteAsync,
    MoreAnswer
  } from "../../assets/js/modules/wordsAp.js";
  import {
    getThumbsDel,
    CancelLike
  } from "../../assets/js/modules/articleApi.js";
  import AvatarImg from "../../assets/img/host.jpg";
  import Vue from "vue";
  import Confirm from "../../components/common/confirm.vue";
  import Login from "../../components/common/login.vue";

  export default {
     props: {
        SourceID: {
            // default: "53"//文件id
        },
        Type:{
          // default:"1"//类型
        }
    },
    data() {
      return {
        userInfo: {
          Avatar: AvatarImg
        },
        commentdata: {
          TotalCount: 0,
          Items: []
        },
        count: "",
        mycount: "",
        AnswerResultCount: 3,
        MaxResultCount: 3,
        //  登录框
        isShow: false,
        bgShow: false,
        //  删除评论数据
        delCommentId: "",
        delCommentIndex1: "",
        delCommentIndex2: ""
      };
    },
    methods: {
      addcomment(index1, index2) {
        if (this.userInfo.Id) {
          if (index2 < 0) {
            if (this.commentdata.Items[index1].flag) {
              this.commentdata.Items[index1].flag = !this.commentdata.Items[
                index1
              ].flag;
            } else {
              Vue.set(this.commentdata.Items[index1], "flag", true); //正确姿势
            }
          } else if (index2 > -1) {
            if (this.commentdata.Items[index1].AnswerList[index2].flag) {
              this.commentdata.Items[index1].AnswerList[index2].flag = !this
                .commentdata.Items[index1].AnswerList[index2].flag;
            } else {
              Vue.set(this.commentdata.Items[index1].AnswerList[index2],"flag", true ); //正确姿势
              // console.log(this.commentdata.Items[index1].AnswerList[index2]);
            }
          }
        } else {
          this.isShow = true;
        }
      },
      commentname(name) {
        return "回复" + name + ":";
      },
      getListasync(SkipCount) {
        let data = {
          SourceID: this.SourceID,
          Type: this.Type,
          UserId: this.userInfo.Id,
          AnswerResultCount: this.AnswerResultCount,
          SkipCount: SkipCount,
          MaxResultCount: this.MaxResultCount
        };

        GetSourceListAsync(data).then(
          res => {
            
            this.commentdata.TotalCount = res.data.Data.TotalCount;
            this.commentdata.Items = this.commentdata.Items.concat(
              res.data.Data.Items
            );

          },
          error => {
            console.log(error);
          }
        );
      },
      CreateComment(index1, index2, Content, AnswerID, AnswerUserID, AnswerName) {
        if (this.userInfo.Id) {
          let data = {
            SourceID: this.SourceID,
            Type: this.Type,
            Content: Content,
            PublishID: this.userInfo.Id,
            AnswerID: AnswerID,
            AnswerUserID: AnswerUserID
          };

          if (Content) {
            CreateAsync(data).then(
              res => {
                var Reply = res.data.Data;
                Reply.Avatar = this.userInfo.Avatar;
                Reply.CreationFormatTime = "刚刚";
                Reply.JobNo = this.userInfo.JobNo;
                Reply.LikeCount = 0;
                Reply.Name = this.userInfo.Name;
                Reply.LikeId = null;
                Reply.AnswerCount = 0;
                Reply.AnswerList = [];
                if (index1 < 0) {
                  this.commentdata.Items.unshift(Reply);
                  this.mycount = "";
                  this.commentdata.TotalCount++;
                  this.$emit("totalCount",true);
                } else if (index1 >= 0) {
                  Reply.AnswerName = AnswerName;
                  Reply.AnswerList = [];
                  this.addcomment(index1, index2);
                  this.commentdata.Items[index1].AnswerCount++;
                  if (index2 < 0) {
                    this.commentdata.Items[index1].count = "";
                  } else {
                    this.commentdata.Items[index1].AnswerList[index2].count = "";
                  }
                  this.commentdata.Items[index1].AnswerList.unshift(Reply);
                }
              },
              error => {
                console.log(error);
              }
            );
          }
        } else {
          this.isShow = true;
        }
      },
      // 更多回复
      getMoreAnswer(AnswerID, index, SkipCount) {
        let data = {
          AnswerID: AnswerID,
          Type: this.Type,
          UserId: this.userInfo.Id,
          SkipCount: SkipCount,
          MaxResultCount: 10
        };
        MoreAnswer(data).then(
          res => {
            this.commentdata.Items[index].AnswerList = this.commentdata.Items[index].AnswerList.concat(res.data.Data.Items);
          },
          error => {
            console.log(error);
          }
        );
      },
      // 删除评论
      delComment(Id, index1, index2) {
        this.$refs.confirm.openConfirm("确定删除评论?");
        this.delCommentId = Id;
        this.delCommentIndex1 = index1;
        this.delCommentIndex2 = index2;
      },
      getMoreCount(SkipCount) {
        this.getListasync(SkipCount);
      },
      // 提交点赞
      addThumbsDel(SourceID, index1, index2) {
        let data = {
          SourceID: SourceID,
          UserID: this.userInfo.Id,
          SourceType: 3,
          Type: 1
        };
        getThumbsDel(data).then(
          res => {
            if (res.data.Success) {
              let LikeId = SourceID;
              if (index2 < 0) {
                this.commentdata.Items[index1].LikeCount++;
                this.commentdata.Items[index1].LikeId = res.data.Data.Id;
              } else {
                this.commentdata.Items[index1].AnswerList[index2].LikeCount++;
                this.commentdata.Items[index1].AnswerList[index2].LikeId = res.data.Data.Id;
              }
            }
          },
          error => {
            alert(1);
          }
        );
      },
      // 取消点赞
      LikeDel(LikeId, index1, index2) {
        let data = {
          FileComprehensiveId: LikeId,
          UserId: this.userInfo.Id
        };

        CancelLike(data).then(
          res => {
            if (res.data.Success) {
              if (index2 < 0) {
                this.commentdata.Items[index1].LikeCount--;
                this.commentdata.Items[index1].LikeId = "";
              } else {
                this.commentdata.Items[index1].AnswerList[index2].LikeCount--;
                this.commentdata.Items[index1].AnswerList[index2].LikeId = "";
              }
            }
          },
          error => {
            alert(1);
          }
        );
      },
      //  取消或点赞
      DelOrLike(LikeId, Id, index1, index2) {
        if (this.userInfo.Id) {
          if (LikeId > 0) {
            this.LikeDel(LikeId, index1, index2);
          } else {
            this.addThumbsDel(Id, index1, index2);
          }
        } else {
          this.isShow = true;
        }
      },
      //  删除评论
      confirmDelComment(data) {
        this.$refs.confirm.closeConfirm();
        if (data.handel) {
          let data = {
            Id: this.delCommentId
          };

          DeleteAsync(data).then(
            res => {
              if (this.delCommentIndex2 < 0) {
                this.commentdata.Items.splice(this.delCommentIndex1, 1);
                this.commentdata.TotalCount--;
                this.$emit("totalCount",false)
              } else {
                this.commentdata.Items[this.delCommentIndex1].AnswerList.splice(this.delCommentIndex2, 1);
                this.commentdata.Items[this.delCommentIndex1].AnswerCount--;
              }
            },
            error => {}
          );
        }
      },

      // 关闭登录
      close(data) {
        if (data) {
          this.isShow = false;
        }
      }
    },
    filters: {},
    mounted() {
      if (window.localStorage.userInfo) {
        this.userInfo = JSON.parse(window.localStorage.userInfo);
      }
      this.getListasync(0);
    },
    components: {
      Confirm,
      Login
    }
  };

</script>
<style scoped>
  
  .reviewArea {
    display: flex;
  }

  .comment-input {
    border: 1px solid #c6c8ce;
  }

  .l-text {
    flex: 1;
    padding-left: 10px;

  }

  .l-text-x {
    width: 90%;

    padding-left: 10px;
    /* flex: 1; */
    box-sizing: border-box;
    /* padding-block: 7px; */
  }

  .pl-text-top {
    float: left;
    line-height: 50px;
    padding: 0 0 0 10px;
    height: 50px;
  }

  .flex-text-wrap {
    width: 100%;
    position: relative;
    *zoom: 1;
  }

  textarea,
  .flex-text-wrap {
    outline: 0;
    margin: 0;
    border: none;
    padding: 0;
    *padding-bottom: 0 !important;
  }

  .frist-input {
    margin-left: 10px;
  }

  .flex-text-wrap textarea {
    *white-space: pre;
    *word-wrap: break-word;
    white-space: pre-wrap;
    width: 900px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
  }

  .flex-text-wrap textarea {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 900px;
    resize: none;
    /* IE7 box-sizing fudge factor */
    *height: 94%;
    *width: 94%;
    border: 1px solid #c6c8ce;
  }

  .flex-text-wrap,
  /* textarea { margin-bottom: 25px } */
  textarea {
    height: 35px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 100%;
    padding: 15px 15px 0;
    /* border: 1px solid #c6c8ce; */
    width: 900px;
    -webkit-appearance: none;
    background: #fff;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    -moz-background-clip: padding;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    flex: 1;
  }

  .fork-link {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 140px;
  }

  /*浮动*/
  .pull-right {
    float: right !important;
  }

  .pull-left {
    float: left !important;
  }

  /*----------------------------------------------------------------------------------------------------------*/
  .content {
    float: left;
  }

  .commentAll {
    max-width: 1280px;
    width: 100%;
    margin: 20px auto;
    padding: 32px 32px 10px;
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    background: #fff;
    color: #666666;
    box-sizing: border-box;
  }

  .plBtn {
    width: 120px;
    height: 50px;
    line-height: 50px;

    text-align: center;
    display: block;
    float: right;
    color: #666666;
    font-size: 14px;
    border-radius: 6px;
    margin-right: 2px;
    margin-left: 20px;
    border: 1px solid #c6c8ce;
  }

  .plBtn:hover {
    background-color: #d1d2d6;
  }

  .comment-all-text {
    border-top: 1px solid #ededed;

    line-height: 1;
    margin-top: 24px;
    padding-top: 20px;
  }

  .comment-show {
    /* padding: 20px 0; */
    background: #fff;
  }

  .comment-show-con {
    width: 100%;
    border-bottom: 1px solid #e7e7e7;
    padding: 20px 0;
  }

  .comment-show-con-img {
    width: 48px;
    height: 48px;
    overflow: hidden;
    margin-top: 2px;
    border-radius: 100%;
  }

  .comment-show-con-img img {
    width: 100%;
    height: 100%;
  }
   .comment-show-con-list{
     width: 100%;
   }
  .comment-show-con-list .comment-div{
    display: flex;
   
  }

  .pl-text {
    width: 100%;
    margin-top: 2px;
    word-wrap: break-word;
    overflow: hidden;
  }

  .date-dz {
    width: 100%;
    float: left;
  }

  .hf-list-con {
    float: left;
    width: 100%;
    background-color: #f6f6f6;
    margin-top: 26px;
    position: relative;
    border-radius: 10px;
    padding-bottom: 12px;
  }

  .hf-list-icon {
    position: absolute;
    top: -20px;
    left: 70px;
  }

  .comment-show {}

  .comment-size-number {
    font-size: 12px;
  }

  .comment-size-name {
    font-size: 12px;
    padding: 0 10px;
    color: #666;
  }

  .comment-time {
    font-size: 12px;
    color: #d9d9d9;

    width: 100%;
  }

  .date-dz-left {
    font-size: 12px;
    /* color: #8b8b8b; */
    display: block;
    padding-top: 18px;
  }

  .my-pl-con,
  .comment-pl-block {
    padding-top: 7px;
    font-size: 14px;
  }

  .comment-pl-block {
    margin-top: 0;
  }

  .date-dz-right {
    display: block;
    padding-top: 6px;

    position: relative;
    overflow: hidden;
  }

  .removeBlock {
    float: left;
    font-size: 12px;
    color: #8b8b8b;
    margin-right: 24px;
    display: block;
  }

  .hf-con-block {
    display: block;
    background: url("../../assets/img/hoard_icon.png") no-repeat;
    padding-left: 20px;
    color: #d9d9d9;
    background-position: 0 0;
    cursor: pointer;
    width: 20px;
    height: 16px;
  }

  .hf-con-block:hover {
    background-position: 0 -19px;
  }

  .date-dz-pl,
  .date-dz-z {
    font-size: 12px;
    color: #d9d9d9;
  }

  .date-dz-z {
    background: url("../../assets/img/hoard_icon.png") no-repeat;
    background-position: left -38px;
    padding-left: 20px;
    margin-left: 50px;
    cursor: pointer;
  }

  .date-dz-z:hover {
    background-position: left -55px;
  }

  .date-dz-z.like {
    background-position: left -55px;
  }

  .date-dz-z-click-red {
    width: 17px;
    height: 17px;
    display: block;
    float: left;
    background-image: url("../../assets/img/host.jpg");
    background-repeat: no-repeat;
    background-position: -6px -198px;
    margin-right: 5px;
  }

  .z-num {
    font-style: normal;
  }

  .date-dz-z-click {
    color: #b83b44;
  }

  .red {
    background-position: -6px -119px !important;
  }

  .hf-pl {
    width: 120px;
    height: 50px;
    line-height: 30px;
    background-color: #fff;
    text-align: center;
    display: block;
    float: right;
    color: #666666;
    font-size: 14px;
    border-radius: 6px;
    margin-left: 15px;
    line-height: 50px;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    cursor: pointer;
  }

  .hf-con {
    width: 86%;
    margin: 0 auto;
    margin-top: 12px;
    display: flex;
  }

  .hf-con.show {}

  .hf-input {
    font-size: 12px;
  }

  .all-pl-con {
    width: 100%;

    padding: 10px 0 0 0;
    margin: 0 2%;
    box-sizing: border-box;
    display: flex;
  }

  .atName {
    font-size: 12px;
    color: #339b53;
  }

  .hfpl-text {
    margin-top: 0;
  }

  .date-dz:hover .removeBlock {
    opacity: 1;
  }

  .hf-list-con >div {
    width: 100%;
  }

  .hf-list-con .all-pl-con:first-child {
    border-top: 0;
  }

  .comment-show—more {
    font-size: 14px;
    text-align: center;
    line-height: 3;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/comment.vue